module.exports = __webpack_public_path__ + "static/img/Ben-Camporeale.cda8e3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Camporeale.jpg
// module id = fDbk
// module chunks = 0